import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Plus = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0",
            width: style.fontSize,
            height: style.fontSize,
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    fill: "none",
                    d: "M0 0h24v24H0V0z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                })
            ]
        })
    });
};
export default Plus;
